<template lang="pug">
  nav.navbar.barra-governo-fix#nav(:class="navbarFixed")
    .container.hack-tablet
      .navbar-header
        transition(name="fade")
          router-link.navbar-brand(:to="{ name: 'Index' }", title="Ir para a página inicial" v-if="isMobile || isScroll")
            .logo
        button.navbar-toggle#menu(type='button' data-toggle='collapse' data-target='#navbar' aria-controls='navbar' aria-expanded='false' aria-label='Menu do Site' @click="toggleMenuButton" )
          span.sr-only Menu de navegação
          i.fa.fa-bars.fa-lg.icon
      transition(name="fade")
        #navbar.navbar-collapse(aria-expanded='false', :class="navbarStates" v-if="isOpen || !isMobile")
          ul.nav.navbar-nav(v-click-outside="watchMenu")
            li(:class="dropdownStates")
              a(class="dropdown-toggle" href="" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="true" @click.prevent="toggleDropdown" v-click-outside="closeDropdown") Institucional
              ul.dropdown-menu(v-if="isActiveDropdown")
                li: router-link(:to="{ name: 'Institucional', params: { slug: 'apresentacao' } }" @click.native="toggleMenu") Apresentação
                li: router-link(:to="{ name: 'Institucional', params: { slug: 'acoes' }  }" @click.native="toggleMenu") Ações
                li
                  a(href="https://calendar.google.com/calendar/embed?src=proadufrn%40gmail.com&ctz=America%2FFortaleza" target="_blank") Agenda Administrativa
                li: router-link(:to="{ name: 'Institucional', params: { slug: 'equipe' }  }" @click.native="toggleMenu") Equipe
                li: router-link(:to="{ name: 'Institucional', params: { slug: 'organograma' } }" @click.native="toggleMenu") Organograma
                li: router-link(:to="{ name: 'Unidades' }" @click.native="toggleMenu") Unidades
            li: router-link(:to="{ name: 'Noticias' }" @click.native="toggleMenu") Notícias
            li: router-link(:to="{ name: 'Categorias' }" @click.native="toggleMenu") Documentos
            li: router-link(:to="{ name: 'Galeria' }" @click.native="toggleMenu") Galeria
            li: router-link(:to="{ name: 'Contato' }" @click.native="toggleMenu") Fale Conosco
            li.divider.hidden-md.hidden-lg(role="separator")
            li.hidden-md.hidden-lg: router-link(:to="{ name: 'Busca' }" @click.native="toggleMenu") Busca
            //- li.hidden-md.hidden-lg: a(href="#") Contraste
            li.hidden-md.hidden-lg: router-link(:to="{ name: 'Sitemap' }" @click.native="toggleMenu") Mapa do Site
</template>

<script>
  export default {

    name: 'page-navbar',

    data () {
      return {
        buttonClick: false,
        isOpen: false,
        isScroll: false,
        isMobile: false,
        isActiveDropdown: false
      }
    },

    computed: {
      navbarFixed: function () {
        return {
          'navbar-fixed-top': this.isMobile || this.isScroll
        }
      },
      navbarStates: function () {
        return {
          'collapse': !this.isOpen,
          'in': this.isOpen
        }
      },
      dropdownStates: function () {
        return {
          'open': this.isActiveDropdown
        }
      }
    },
    methods: {
      toggleOverlay () {
        if (this.isOpen) {
          document.body.className = '-overflowed'
        } else {
          document.body.className = ''
        }
      },
      toggleDropdown () {
        this.isActiveDropdown = !this.isActiveDropdown
      },
      closeDropdown () {
        this.isActiveDropdown = false
      },
      openDropdown () {
        this.isActiveDropdown = true
      },
      toggleMenu () {
        if (this.isMobile) {
          this.isOpen = !this.isOpen
          this.toggleOverlay()
          if (this.buttonClick) {
            this.buttonClick = false
          }
        }
      },
      toggleMenuButton () {
        this.buttonClick = !this.buttonClick
        this.toggleMenu()
      },
      openMenu () {
        this.isOpen = true
        document.body.className = '-overflowed'
      },
      closeMenu () {
        this.isOpen = false
        document.body.className = ''
        this.buttonClick = false
      },
      watchMenu () {
        if (this.isOpen && document.body.className) {
          // this.closeMenu()
        }
      },
      fixedNavbar () {
        if (!this.isMobile) {
          if (this.isScroll === true) {
            // document.body.style.marginTop = '50px'
          } else {
            // document.body.style.marginTop = '0px'
          }
        }
      },
      checkIsMobile () {
        this.isMobile = (window.innerWidth < 992)
      },
      checkIsScroll () {
        this.isScroll = (window.scrollY >= 246)
        let el = document.getElementById('nav')
        if (window.scrollY > 50) {
          el.classList.remove('barra-governo-fix')
        }
        if (window.scrollY === 0) {
          el.classList.add('barra-governo-fix')
        }
      },
      checkOnScroll () {
        this.checkIsScroll()
        this.fixedNavbar()
      },
      checkOnResize () {
        this.checkIsMobile()
      }
    },

    created () {
      window.addEventListener('scroll', this.checkOnScroll)
      window.addEventListener('resize', this.checkOnResize)
    },

    mounted () {
      this.checkIsMobile()
    }
  }
</script>

<style lang="scss">
  #nav {
    margin-bottom: 0;
    border-radius: 0;
    z-index: 1010;

    &.barra-governo-fix {
      @include media("<desktop") {
        top: 33px;
      }
    }

    .divider {
      width: 90%;
      height: 2px;
      background-color: #D8D9DD;
      margin: 10px auto;
    }

    .navbar-header {
      > .navbar-brand {
        height: auto;
        padding: 0;
        margin: 20px 15px;
        > .logo {
          display: block;
          width: 111px;
          height: 30px;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      > .navbar-toggle {
        margin: 18px 15px;
        font-size: 24px;
        padding: 0;
        border: 0;
        > .icon { color: $color-blue-dark }
      }
    }

    // MOBILE RULES
    @include media("<desktop") {
      .navbar-header {
        background-color: $color-neutral;
        border-bottom: 1px solid #ccc;
        box-shadow: 1px 3px 10px rgba(0,0,0,0.5);
        > .navbar-brand > .logo { background-image: url('../../../static/logo_mobile.png') }
        > .navbar-toggle { display: block }
      }
    }

    // TABLET RULES
    @include media(">=tablet","<desktop") {
      .navbar-header {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
      }
    }

    // DESKTOP RULES
    @include media(">=desktop") {
      background-color: $color-blue-dark;
      box-shadow: 0 3px 10px rgba(0,0,0,0.5);
      border: 0;

      .navbar-header {
        position: absolute;
        margin: 9px 0;
        > .navbar-brand {
          margin: 0;
          > .logo {
            // display: none;
            width: 115px;
            height: 31px;
            background-image: url('../../../static/logo_rolagem.png');
          }
        }
      }

      .navbar-collapse {
        > .nav.navbar-nav > li > a {
          color: $color-neutral;
        }
      }
    }
  }

  #navbar {

    .navbar-nav {
      width: 100%;
      margin: 0 auto;
    }

    > .navbar-nav > li.open > a,
    > .navbar-nav > li > a:hover,
    > .navbar-nav > li > a:focus {
      background-color: #56ccf2;
      color: #00607d !important;
    }

    > .navbar-nav > li > a {
      text-transform: uppercase;
      font-size: 18px;
    }

    .dropdown-menu {
      border: 0;
      > li > a {
        @include iconFA('before', '\f0da');
        @extend %font_medium;
        font-size: 18px;
        color: $color-grey-dark;
        &:before { margin-right: 7px; color: $color-blue-dark; }
        &:hover { color: $color-green-dark; }
      }
    }

    @include media("<desktop") {
      background-color: #EDEEF0;
      margin-left: 0;
      margin-right: 0;
      padding: 0;
      max-height: 345px;

      &:not(.in) {
        height: 0 !important;
      }

      .navbar-nav {
        height: inherit;
        > li > a {
          color: $color-grey-dark;
          font-weight: 800;
        }
      }

      .dropdown-menu {
        margin: 0 0 10px 0;
        > li > a { padding: 7px 15px 7px 25px }
      }
    }

    @include media(">=tablet","<desktop") {
      float: right;
      width: 30%;
      margin-right: 15px;
      max-height: 100%;
      .navbar-nav { overflow-y: auto }
      .navbar-nav > li { width: 100%; }
    }

    @include media(">=desktop") {
      .navbar-nav {
        text-align: center;
        > li {
          float: none;
          display: inline-block;
        }
        > li > a { font-weight: 500; padding: 15px 20px; }
      }
      .dropdown-menu {
        > li > a {
          font-size: 16px;
          padding: 5px 15px;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// PageNavbar.vue?978a6c6a